import { render } from "./DashboardTV3.vue?vue&type=template&id=7b75efba"
import script from "./DashboardTV3.vue?vue&type=script&lang=js"
export * from "./DashboardTV3.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__